/*
  These are still in a use in a few places because of lack of time to be replaced, with teh TZ functions.
*/

import moment from 'moment';
import isoLanguageCodeEnum from '../enums/isoLanguageCodeEnum';

const getDateFormat = (date) => moment(date).format('MM/DD/YYYY');

export default getDateFormat;

export const getDisplayDateOnTextFiled = (date) =>
  date ? moment.utc(date).format('YYYY-MM-DD') : moment.utc().format('YYYY-MM-DD');

export const getDateWithTime = (date) => moment.utc(date).format('YYYY-MM-DD hh:mm:ss A');

export const getDateFromMilliSec = (dateInMilliSec) => {
  let date = new Date(dateInMilliSec);
  return date.toLocaleString(isoLanguageCodeEnum.EN_US);
};

export const getDateWithTimeZone = (date) => {
  return new Date(date).toLocaleString(navigator.language, {
    timeZone: 'America/Los_Angeles',
    timeZoneName: 'short',
  });
};
